import React, { CSSProperties } from "react";
import "./Check.scss";

interface CheckProps {
  checked: boolean | undefined;
  neverChecked?: boolean;
  outline?: boolean;
  className?: string;
  style?: CSSProperties;
  onClick: (
    checked: boolean,
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  children: React.ReactNode;
  id?: string;
}

export function Check(props: CheckProps) {
  const consideredChecked =
    props.checked || (props.outline && props.neverChecked);
  return (
    <button
      className={`check ${props.checked ? "checked" : "unchecked"} ${
        props.outline ? "outline" : ""
      } no-wrap-text ${props.className}`}
      style={props.style}
      onClick={(e) => {
        props.onClick(!props.checked, e);
      }}
      id={props.id}
      role="checkbox"
      aria-checked={consideredChecked}
      aria-label={`${consideredChecked ? "Deselect" : "Select"} ${
        props.children
      }`}
    >
      {props.children}
    </button>
  );
}
